import { defineStore } from 'pinia'

type BouyguesNormalizedAddress = {
  additionalInformation: string
  firstName: string
  lastName: string
  locality: string
  postCode: string
  streetName: string
  streetNumber: string
}

type PhonelineSetupInformation = {
  iban: string
  phoneNumber: string | null
  rioCode: string | null
  childrenOnlineProtection: boolean
}

interface BouyguesStore {
  authorizationCode: string | null
  shippingAddress: BouyguesNormalizedAddress | null
  billingAddress: BouyguesNormalizedAddress | null
  phonelineSetupInformation: PhonelineSetupInformation | null
}

export const useBouyguesStore = defineStore('bouygues', {
  state: (): BouyguesStore => ({
    authorizationCode: null,
    shippingAddress: null,
    billingAddress: null,
    phonelineSetupInformation: null,
  }),

  actions: {
    setPhonelineSetupInformation(
      phonelineSetupInformation: PhonelineSetupInformation,
    ) {
      this.phonelineSetupInformation = phonelineSetupInformation
    },
    setAuthorizationCode(
      authorizationCode: BouyguesStore['authorizationCode'],
    ) {
      this.authorizationCode = authorizationCode
    },
  },
})
